import {useQueries} from "@tanstack/react-query";
import locationService from "../../../../services/web/location-service.js";
import teamService from "../../../../services/web/team-service.js";
import areaLayerService from "../../../../services/web/area-layer-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['locationTypes'],
                queryFn: () => locationService.getLocationType().then(data => data.map(({id, text}) => ({value: id, label: text}))),
                initialData: []
            },
            {
                queryKey: ['place'],
                queryFn: () => locationService.getLocations().then(data => data.map(({id, text}) => ({value: id, label: text}))),
                initialData: []
            },
            {
                queryKey: ['teams'],
                queryFn: () => teamService.getAll(),
                initialData: []
            },
            {
                queryKey: ['sectors'],
                queryFn: () => areaLayerService.allSectors(),
                initialData: []
            },
        ]
    });

    return {
        locationTypes: queries[0].data,
        placeOptions: queries[1].data,
        teams: queries[2].data.data,
        sectors: queries[3].data
    };
};

export default UseFetchOptions;